import React from 'react';
import { StyledLoader } from './Loader.styles';

export const Loader = () => <StyledLoader />;
